import React from 'react';
import { useTranslation } from 'react-i18next';
import { TriangleAlert, X } from 'lucide-react';
import { cn } from 'lib/utils';
import { WarningLevel } from 'components/shared/WarningLevel';

type Props = {
  message: string;
  level: WarningLevel;
  isClosable: boolean;
  isGlobal?: boolean;
  link?: string;
  onClose: () => void;
  onDismissPermanently?: () => void;
};

function WarningBar({ message, isGlobal = false, level, link, isClosable, onClose, onDismissPermanently }: Props) {
  const { t } = useTranslation('navigation');

  return (
    <div
      className={cn(
        'relative flex w-full items-center px-7 py-5 text-white',
        isGlobal && 'h-18',
        level === WarningLevel.IMPORTANT ? 'bg-[#ef4e45]' : 'bg-[#f79f38]',
      )}
    >
      <TriangleAlert className="mr-8 min-w-6 shrink-0" />
      <span>
        {t('importantMessage')}
        {message}
        {link && (
          <a className="ml-1.5 underline" href={link} target="_blank" rel="noopener noreferrer">
            {`> ${t('clickHere')}`}
          </a>
        )}
      </span>
      {isClosable && (
        <div className="absolute top-1/2 right-6 flex -translate-y-1/2 items-center gap-3">
          {onDismissPermanently && (
            <button
              type="button"
              onClick={onDismissPermanently}
              className="text-xs underline underline-offset-2 opacity-80 hover:opacity-100"
            >
              {t('dismissPermanently')}
            </button>
          )}
          <X className="cursor-pointer opacity-80 hover:opacity-100" onClick={onClose} />
        </div>
      )}
    </div>
  );
}

export default WarningBar;
